import { Training } from '@/app/entities/Training'
import { formatDuration } from '@/app/utils/formatDuration'

import { ClockIcon, ListVideoIcon } from 'lucide-react'
import { Link } from 'react-router-dom'

interface TrainingCardProps {
  training: Training
  isEven: boolean
}

export function TrainingCard({ training, isEven }: TrainingCardProps) {
  const link = `/conteudos/listar/treinamentos/${training?._id}`

  return (
    <Link
      to={link}
      className="relative flex h-[144px] flex-col gap-2 rounded-2xl border p-5"
    >
      <div
        className="absolute inset-0 z-10"
        style={{
          backgroundImage: `url(/training_banner.png)`,
          backgroundSize: 'contain',
          backgroundPosition: 'right',
          backgroundRepeat: 'no-repeat',
          transform: isEven ? 'scaleY(-1)' : 'scaleY(1)',
        }}
      />
      <h1 className="relative z-20 text-xl font-semibold">{training.name}</h1>
      <p className="relative z-20 flex items-center gap-2 text-sm text-gray-500">
        <ClockIcon className="h-4 w-4" />
        {formatDuration(training?.duration)}
      </p>
      <p className="relative z-20 flex items-center gap-2 text-sm text-gray-500">
        <ListVideoIcon className="h-4 w-4" />
        {training?.lessonsLength} aulas
      </p>
    </Link>
  )
}
